module.exports = __webpack_public_path__ + "static/assets/0d3a8a56391c50dc23222fd902b68c20.svg";